// 小米负一屏go机型
export default {
  // 小米天气的小部件英文域名
  "en-miwg.comfortweather.com": {
    ad1: [
      {
        // type: "adx",
        // id: "div-gpt-ad-1747137553356-0",
        // slot: "/22175678864/encomforweather_320*100_ad1",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },
        // position: "position-12",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1747137573149-0",
        // slot: "/22175678864/encomforweather_320*100_ad2",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },
        // position: "position-07",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1748330825843-0",
        // slot: "/22175678864/encomforweather_320*100_ad3",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "anchor",
        slot: "/22175678864/encomforweather_320*50_xidi",
        position: "position-01",
      },
    ],
    ad2: [
      {
        // <!--now-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 7947606266,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-08",
      },
      {
        // <!--hourly-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 9787317455,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-11",
      },
      {
        // <!--daily：-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 4626474204,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-09",
      },

      {
        // <!--sun:-->
        type: "ads",
        client: "ca-pub-2826423230659304",
        slot: 5848072449,
        style: {
          display: "inline-block",
          width: "300px",
          height: "250px",
        },
        position: "position-10",
      },

      {
        // <!--home-->
        // type: "ads",
        // client: "ca-pub-2826423230659304",
        // slot: 9012501806,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },
        // position: "position-21",
      },
    ],
  },
  // 小米印地语域名
  "hi-miwg.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1747137469838-0",
        slot: "/22175678864/hicomforweather_320*100_ad1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-12",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1747137489725-0",
        slot: "/22175678864/hicomforweather_320*100_ad2",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-07",
      },
    ],
    ad2: [],
  },
  // 小米印尼语域名
  "id-miwg.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1747137287379-0",
        slot: "/22175678864/idcomforweather_320*100_ad1",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-12",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1747137370092-0",
        slot: "/22175678864/idcomforweather_320*100_ad2",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-07",
      },
    ],
    ad2: [],
  },
  // go机型新增单独俄罗斯的子域名
  "rs-miwg.comfortweather.com": {
    ad1: [
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175136525865837369",
        p1: "dikbk",
        p2: "jfhk",
        position: "position-12",
      },
      {
        type: "dex",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175136529517117369",
        p1: "dikbl",
        p2: "jfhk",
        position: "position-07",
      },
      {
        type: "floorAd",
        lazyLoad: { fetchMargin: 100, mobileScaling: 1.5 },
        ownerId: 11635561,
        containerId: "adfox_175136531381017369",
        p1: "dikbm",
        p2: "jkqc",
        platform: "touch",
        position: "position-01",
      },
    ],
    ad2: [],
  },
};
